import EmailLogsTable from "./EmailLogsTable";

const EmailLogs = () => {
  return (
    <>
      <EmailLogsTable />
    </>
  );
};

export default EmailLogs;
